import { render, staticRenderFns } from "./ExcelReporteSupervision.vue?vue&type=template&id=2c1c2288&"
import script from "./ExcelReporteSupervision.vue?vue&type=script&lang=js&"
export * from "./ExcelReporteSupervision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports